import React from 'react';
import PropTypes from 'prop-types';
import BasicFormField from '../../../common/formFields/basicFormField';
import TextArea from '../../../common/textarea';
import CheckboxSwitch from '../../../common/checkboxSwitch';
import ColorPickerField from '../../../common/ColorPickerField';
import FormSection from '../../../common/FormSection';
import FileInput from '../../../common/fileInput';
import { TERRITORIES } from '../constants';
import UploadImageAsset from './UploadImageAsset';
import SelectMultipleField from './SelectMultipleField';
import SelectField from './SelectField';

const CustomAppForm = ({ extension }) => (
  <div className="layout">
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">App Store Settings</div>
    <BasicFormField
      placeholder="Required for iOS/Android"
      label="App Store Name"
      name="extension.iTunesName"
      maxLength="255"
    />
    <BasicFormField
      placeholder="Required for iOS/Android"
      label="App Name"
      name="extension.name"
      maxLength="255"
    />
    <BasicFormField
      placeholder="Required for iOS/Android"
      label="App Display Name"
      name="extension.appName"
      maxLength="30"
      wrapperClass="layout__item u-1"
    />
    <div className="layout__item">
      <div className="c-label-new">App Store Description</div>
      <TextArea
        className="c-textarea"
        name="extension.iTunesDescription"
        placeholder="Required for iOS and Android"
        maxLength="4000"
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">App Store Short Description</div>
      <TextArea
        className="c-textarea"
        name="extension.googlePlayShortDescription"
        placeholder="Required for Android"
        maxLength="80"
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">App Store Keywords</div>
      <TextArea
        className="c-textarea"
        name="extension.iTunesKeywords"
        placeholder="Required for iOS"
        maxLength="100"
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">Internal App Notes</div>
      <TextArea
        className="c-textarea"
        name="extension.notes"
        placeholder="App Notes"
        maxLength="4000"
      />
    </div>
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">Appearance</div>
    <UploadImageAsset name="extension.appIconImage" label="App Icon Image (1024x1024)" />
    <UploadImageAsset name="extension.appIconForegroundImage" label="App Icon Foreground Image (1024x1024)" />
    <UploadImageAsset name="extension.googlePlayFeatureGraphicImage" label="App Store Feature Graphic Image (1024x500)" />
    <UploadImageAsset name="extension.logoImage" label="Logo Image (1024x1024)" />
    <UploadImageAsset name="extension.smallLogoImage" label="Small Logo Image (640x640)" />
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-" />
    <ColorPickerField name="extension.primaryColor" label="Primary Color" />
    <ColorPickerField name="extension.primaryColorDarker" label="Primary Color Darker" />
    <ColorPickerField name="extension.secondaryColor" label="Secondary Color" />
    <ColorPickerField name="extension.linkColor" label="Link Color" />
    <ColorPickerField name="extension.primaryFontColor" label="Primary Font Color" />
    <div className="c-separator u-mv" />
    <FormSection title="Appearance (Legacy)">
      <UploadImageAsset name="extension.backgroundImage" label="Background Image" />
      <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-" />
      <ColorPickerField name="extension.signupButtonColor" label="Signup Button Color" />
      <ColorPickerField name="extension.loginButtonColor" label="Login Button Color" />
      <ColorPickerField name="extension.barColor" label="Bar Color" />
      <ColorPickerField name="extension.barColorAlpha" label="Bar Color Alpha" />
      <SelectField
        className="c-select"
        name="extension.region"
        label="App Region"
        options={TERRITORIES}
        empty
      />
      <BasicFormField
        placeholder="Background Alpha"
        label="Background Alpha"
        name="extension.backgroundAlpha"
        maxLength="2"
        normalize={value => (value ? Number(value) : null)}
      />
      <BasicFormField
        placeholder="Logo Leading"
        label="Logo Leading"
        name="extension.logoLeading"
        maxLength="3"
        normalize={value => (value ? Number(value) : null)}
      />
      <BasicFormField
        placeholder="Logo Trailing"
        label="Logo Trailing"
        name="extension.logoTrailing"
        maxLength="3"
        normalize={value => (value ? Number(value) : null)}
      />
      <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-" />
      <CheckboxSwitch
        name="extension.oversizedSmallLogo"
        id="extension.oversizedSmallLogo"
        label="Oversized Small Logo"
        wrapperClass="layout__item u-1/2-medium-and-up"
      />
      <CheckboxSwitch
        name="extension.centerLogo"
        id="extension.centerLogo"
        label="Center Homescreen Logo"
        wrapperClass="layout__item u-1/2-medium-and-up"
      />
      <CheckboxSwitch
        name="extension.usePostal"
        id="extension.usePostal"
        label="Use Postal instead of ZIP"
        wrapperClass="layout__item u-1/2-medium-and-up"
      />
      <CheckboxSwitch
        name="extension.noTaxLabel"
        id="extension.noTaxLabel"
        label="Hide Tax Label"
        wrapperClass="layout__item u-1/2-medium-and-up"
      />
      <CheckboxSwitch
        name="extension.showPromotions"
        id="extension.showPromotions"
        label="Show Promotions Tab"
        wrapperClass="layout__item u-1/2-medium-and-up"
      />
      <CheckboxSwitch
        name="extension.showHours"
        id="extension.showHours"
        label="Show Hours Tab"
        wrapperClass="layout__item u-1/2-medium-and-up"
      />
    </FormSection>
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mt-- u-mb-" >Apple Developer Settings</div>
    <BasicFormField
      placeholder="Bundle Identifier"
      label="Bundle Identifier"
      name="extension.identifier"
      maxLength="255"
    />
    <BasicFormField
      placeholder="Merchant Identifier"
      label="Merchant Identifier"
      name="extension.merchantId"
      maxLength="255"
    />
    <BasicFormField
      placeholder="Team Name"
      label="Team Name"
      name="extension.teamName"
      maxLength="255"
    />
    <BasicFormField
      placeholder="Developer Team ID"
      label="Developer Team ID"
      name="extension.teamId"
      maxLength="255"
    />
    <BasicFormField
      placeholder="ITC Provider"
      label="ITC Provider"
      name="extension.itcProvider"
      maxLength="255"
    />
    <BasicFormField
      placeholder="App Store Team ID"
      label="App Store Team ID"
      name="extension.itunesTeamId"
      maxLength="255"
    />
    <BasicFormField
      placeholder="iTunes Link"
      label="iTunes Link"
      name="extension.iTunesLink"
      maxLength="255"
      normalize={value => (value || null)}
    />
    <BasicFormField
      placeholder="iTunes Marketing Link"
      label="iTunes Marketing Link"
      name="extension.iTunesMarketingLink"
      maxLength="255"
      normalize={value => (value || null)}
    />
    <BasicFormField
      placeholder="iTunes Support Link"
      label="iTunes Support Link"
      name="extension.iTunesSupportLink"
      maxLength="255"
      normalize={value => (value || null)}
    />
    <BasicFormField
      placeholder="SKU"
      label="SKU"
      name="extension.sku"
      maxLength="255"
    />
    <SelectMultipleField
      name="extension.territories"
      label="App Store Territories"
      options={TERRITORIES}
    />
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-" />
    <BasicFormField
      placeholder="Key ID"
      label="App Store Connect API Key ID"
      name="extension.appStoreConnectApiKeyId"
      maxLength="255"
    />
    <BasicFormField
      placeholder="Issuer ID"
      label="App Store Connect API Issuer ID"
      name="extension.appStoreConnectApiIssuerId"
      maxLength="255"
    />
    <BasicFormField
      placeholder="App Store Connect Version"
      label="App Store Connect Version"
      name="extension.appStoreConnectVersion"
      maxLength="255"
      normalize={value => (value || null)}
      disabled
    />
    <div className="layout__item u-1/2-medium-and-up">
      <div className="c-label-new">App Store Connect API Key (.p8)</div>
      <FileInput
        label={extension.appStoreConnectApiKey ? 'Re-upload' : 'Upload'}
        name="extension.appStoreConnectApiKey"
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">App Store Connect Account Status</div>
      <TextArea
        className="c-textarea"
        name="extension.appStoreConnectStatus"
        placeholder="No status"
        maxLength="4000"
        disabled
      />
    </div>
    <div className="c-separator u-mv" />
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">Google Developer Settings</div>
    <BasicFormField
      placeholder="Application ID"
      label="Application ID"
      name="extension.applicationId"
      maxLength="255"
      normalize={value => (value || null)}
    />
    <BasicFormField
      placeholder="Play Store Link"
      label="Play Store Link"
      name="extension.playStoreLink"
      maxLength="255"
      normalize={value => (value || null)}
    />
    <BasicFormField
      placeholder="Google Client ID"
      label="Google Client ID (Google Sign In)"
      name="extension.googleClientId"
      maxLength="255"
      normalize={value => (value || null)}
    />
    <BasicFormField
      placeholder="Google Play Store Version"
      label="Google Play Store Version"
      name="extension.googlePlayVersion"
      maxLength="255"
      normalize={value => (value || null)}
      disabled
    />
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-" />
    <div className="layout__item u-1/2-medium-and-up">
      <div className="c-label-new">Android Firebase Config (JSON)</div>
      <FileInput
        label={extension.firebaseConfig ? 'Re-upload' : 'Upload'}
        name="extension.firebaseConfig"
      />
    </div>
    <div className="layout__item u-1/2-medium-and-up">
      <div className="c-label-new">iOS Firebase Config (PLIST)</div>
      <FileInput
        label={extension.iosFirebaseConfig ? 'Re-upload' : 'Upload'}
        name="extension.iosFirebaseConfig"
      />
    </div>
    <div className="layout__item u-1/2-medium-and-up">
      <div className="c-label-new">Service Account Key (JSON)</div>
      <FileInput
        label={extension.serviceAccountKey ? 'Re-upload' : 'Upload'}
        name="extension.serviceAccountKey"
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">Google Play Account Status</div>
      <TextArea
        className="c-textarea"
        name="extension.googlePlayStatus"
        placeholder="No status"
        maxLength="4000"
        disabled
      />
    </div>
    <div className="c-separator u-mv" />
    <FormSection title="3rd Party Integrations (Legacy)">
      <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">Facebook Ads Settings</div>
      <BasicFormField
        placeholder="Facebook App Identifier"
        label="Facebook App Identifier"
        name="extension.facebookAppIdentifier"
        maxLength="255"
      />
      <BasicFormField
        placeholder="Facebook Display Name"
        label="Facebook Display Name"
        name="extension.facebookDisplayName"
        maxLength="255"
      />
      <div className="c-separator u-mv" />
      <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">Branch.io Ads Settings</div>
      <BasicFormField
        placeholder="Branch Key"
        label="Branch Key"
        name="extension.branchKey"
        maxLength="255"
      />
      <div className="c-separator u-mv" />
      <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">Payments</div>
      <CheckboxSwitch
        name="extension.payworks"
        id="extension.payworks"
        label="Payworks"
        wrapperClass="layout__item u-1/2-medium-and-up"
      />
    </FormSection>
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">Advanced Options</div>
    <BasicFormField
      placeholder="Developer Username"
      label="Developer Username"
      name="extension.username"
      maxLength="255"
    />
    <BasicFormField
      placeholder="Developer Encrypted Password"
      label="Developer Encrypted Password"
      name="extension.encryptedPassword"
      type="password"
      maxLength="255"
    />
    <BasicFormField
      placeholder="App Update Group"
      label="App Update Group"
      name="extension.appUpdateGroup"
      maxLength="255"
    />
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-" />
    <CheckboxSwitch
      name="extension.shouldUpdate"
      id="extension.shouldUpdate"
      label="Should Allow App Updates"
      wrapperClass="layout__item u-1/2-medium-and-up"
    />
    <div className="c-separator u-mv" />
    <FormSection title="Advanced Options (Legacy)">
      <BasicFormField
        placeholder="Scheme Name"
        label="Scheme Name"
        name="extension.scheme"
        maxLength="255"
      />
      <BasicFormField
        placeholder="Passphrase"
        label="Passphrase"
        name="extension.passphrase"
        type="password"
        maxLength="255"
      />
      <CheckboxSwitch
        name="extension.facebookLoginDisabled"
        id="extension.facebookLoginDisabled"
        label="Disable Facebook Login Button"
        wrapperClass="layout__item u-1/2-medium-and-up"
      />
    </FormSection>
  </div>
);

CustomAppForm.propTypes = {
  extension: PropTypes.object,
};

CustomAppForm.defaultProps = {
  extension: {},
};

export default CustomAppForm;
